// extracted by mini-css-extract-plugin
export default {"modal-container":"modal_modal-container__-QpGr","modal-background":"modal_modal-background__C+NIy","modal-box":"modal_modal-box__L47H2","example":"modal_example__nLNYl"};